angular.module('ui.order.orderItemCard.orderItemGridActions', [])

    .directive('orderItemGridActions', function () {
        return {
            restrict: 'E',
            scope: {
                executeAction: "&executeAction"
            },
            templateUrl: 'app/ui/order/orderItemCard/orderItemActions/orderItemActions.html',
            controller: 'OrderItemGridActionsController'
        };
    })

    .controller('OrderItemGridActionsController', function ($timeout, $scope, toastr, $log, $q, $customisationConfig, usersRepository,
                                                            workflowRepository, orderItemsGridSharedSettings, permissions, gettextCatalog,
                                                            focusManagementService, customResourceResolver, orderItemsRepository) {

        $scope.onExecuteActionButtonClick = onExecuteActionButtonClick;
        $scope.isActionButtonEnabled = isActionButtonEnabled;

        orderItemsGridSharedSettings.onSelectionChange('OrderItemGridActionsController', function () {
            initData();
        });

        $scope.$on("$destroy", function () {
            orderItemsGridSharedSettings.onSelectionChange('OrderItemGridActionsController', void 0);
        });

        function transformColor(colorToTransform) {
            var defaultColor = "#8F9499";
            switch (colorToTransform) {
                case "red":
                    return "#EC8678";
                case "green":
                    return "#77DA95";
                case "yellow":
                    return "#EBE176";
                case "violet":
                    return "#AC83E1";
                case "orange":
                    return "#E8B470";
                case "blue":
                    return "#7BB0DE";
                case "grey":
                    return defaultColor;
                default:
                    return defaultColor;
            }
        }

        function initData() {
            var defaultColor = "#8F9499";
            var selectedItemIds = orderItemsGridSharedSettings.getSelectedOrderItemIds();
            if (!selectedItemIds || selectedItemIds.length === 0) {
                $scope.actions = [];
                return;
            }
            var getOrderItemsPromises = _.map(selectedItemIds, function(id) { return orderItemsRepository.getOrderItem(id);});

            $q.all(getOrderItemsPromises).then(function(itemsResult) {
                $scope.orderItems = itemsResult;

                $q.all(
                [
                    usersRepository.getCurrentUser(),
                    workflowRepository.getSteps(),
                    customResourceResolver.resolveWorkflow()
                ])
                .then(function (data) {
                    var restUser = data[0];
                    var steps = data[1];
                    $scope.workflowConfig = data[2];
                    $scope.orderItem = $scope.orderItems.length > 0 ? $scope.orderItems[0] : null;
                    $scope.step = $scope.orderItem.$model.stepCode;
                    var actionsConfig = $scope.workflowConfig.actions;

                    var currentStep = _.find(steps, function (result) {
                        return result.$model.code === $scope.step;
                    });
                    var isCustomer = restUser.isCustomer();
                    var fallbackIconForAction = function (actionCode) {
                        return $customisationConfig.hasResource(function (res) {
                            return _.string.contains(res, actionCode + ".");
                        }) ? actionCode : "workflow";
                    };
                    var actions = [];
                    workflowRepository.getActionsForStep(currentStep.$model.code)
                        .then(function (actionsFromApi) {
                            var promises = [];
                            _.forEach(actionsFromApi, function (value) {
                                var promise = permissions.isActionAllowed(currentStep.$model.id, value.$model.id)
                                    .then(function (isAllowed) {
                                        if (!isAllowed) {
                                            return;
                                        }
                                        var actionConfig = _.find(actionsConfig, function (result) {
                                            return result.code === value.$model.code;
                                        });
                                        if (actionConfig && actionConfig.ignore) {
                                            return; //Ignore the action if configured so in workflow config
                                        }

                                        actions.push({
                                            code: value.$model.code,
                                            name: value.$model.nameResource,
                                            color: angular.isDefined(actionConfig) && angular.isDefined(actionConfig.color) ? transformColor(actionConfig.color) : defaultColor,
                                            uiPriority: angular.isDefined(actionConfig) && angular.isDefined(actionConfig.uiPriority) ? actionConfig.uiPriority : Infinity,
                                            iconName: angular.isUndefined(actionConfig) ? fallbackIconForAction(value.$model.code) : (angular.isDefined(actionConfig.publicImageResourceName) && isCustomer
                                                    ? actionConfig.publicImageResourceName : (angular.isDefined(actionConfig.imageResourceName) ? actionConfig.imageResourceName : fallbackIconForAction(value.$model.code)))
                                        });
                                    });
                                promises.push(promise);
                            });
                            if (promises.length > 0) {
                                return $q.all(promises);
                            }

                            return $q.when(null);
                        })
                        .then(function () {
                            $scope.actions = _.clone(actions);
                            focusManagementService.setFocus();
                        }, function (err) {
                            $scope.actions = [];
                            $log.error("Can't init actions list for orderItem: %s. Cause: %s.", $scope.orderItem ? $scope.orderItem.getId() : undefined, err.message);
                            toastr.error(err.message, gettextCatalog.getString("Can't initialize actions list"));
                        });
                });
            });
        }

        function onExecuteActionButtonClick(actionCode) {
            $scope.executeAction({actionCode: actionCode});
        }

        function isActionButtonEnabled(actionCode) {
            if (!$scope.orderItem && !$scope.orderItems) {
                return false; //Do not allow to click button if we have no order item at all. Nothing to perform action on
            }
            var actionsConfig = $scope.workflowConfig.actions;

            if (actionsConfig) {
                var actionConfig = _.find(actionsConfig, function (result) {
                    return result.code === actionCode;
                });
                if (!angular.isDefined(actionConfig) || !angular.isDefined(actionConfig.isAllowed)) {
                    return true; //We have no validation checks configured for Action - meaning - always allowed
                }
                try {
                    if ($scope.orderItems) {
                        //try to validate if action allowed for each of the selected items
                        var result = true;
                        _.each($scope.orderItems, function(oi) {
                            result &= actionConfig.isAllowed(oi);
                        });
                        return result;
                    }
                    return true;
                } catch (err) {
                    $log.error("Can't validate action [%s] allowance for orderItem: %s. Cause: %s.",
                        actionCode, $scope.orderItem ? $scope.orderItem.getId() : undefined, err.message);
                    return true; //if failed - allow the button to be clicked. probably the validation check has an error inside
                }
            }

            return true;
        }
    })

;
